import Vector from "victor";

export default class ClickDetector {
  originalScreenPoint = new Vector(0, 0);
  lastScreenPoint = new Vector(0, 0);
  isPointerDown = false;
  maxDistanceMovedFromOriginalScreenPoint = 0;

  get isClickAborted(): boolean {
    return this.maxDistanceMovedFromOriginalScreenPoint >= 5;
  }

  abort() {
    this.isPointerDown = false;
  }

  /* Event handlers */

  onPointerDown = (screenPoint: Vector) => {
    this.isPointerDown = true;
    this.originalScreenPoint = screenPoint;
    this.lastScreenPoint = this.originalScreenPoint;
    this.maxDistanceMovedFromOriginalScreenPoint = 0;
  };

  onPointerMove = (screenPoint: Vector) => {
    if (!this.isPointerDown) return;
    this.lastScreenPoint = screenPoint;
    this.maxDistanceMovedFromOriginalScreenPoint = Math.max(
      this.maxDistanceMovedFromOriginalScreenPoint,
      this.lastScreenPoint.distance(this.originalScreenPoint)
    );
  };

  onPointerUp = () => {
    this.abort();
  };
}
